import { useState, useEffect, useCallback } from 'react';
import { producaov2 } from '../services/apis';

/**
 * 
 * @param {string} url - URL da api
 * @returns
 */
export default function useAPI(url) {
  const [data, setData] = useState();
  const [headers, setHeaders] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadData = useCallback(async () => {
    setIsLoading(true);

    try {
      const response = await producaov2.get(url);

      setHeaders(response.headers);

      return response.data;
    } catch(error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }, [url]);

  useEffect(() => {
    let isMounted = true;

    const loadInitialData = async () => {
      const data = await loadData();

      if(isMounted) {
        setData(data);
      }
    }

    loadInitialData();

    return () => {
      isMounted = false;
    }
  }, [url]);

  const refreshData = useCallback(async () => {
    const data = await loadData();

    setData(data);
  }, [loadData]);

  return {
    data,
    headers,
    isLoading,
    error,
    refreshData
  };
}